import React from "react";

// Placeholder for the TSP Notifications screen. Business logic, data fetching and
// layout will be implemented in the TSP feature phase that covers this area
// (see CLAUDE.md Section 50 — Development Phases).
export default function TspNotificationsPage() {
  return <div className="tsp-page">TSP Notifications — coming soon</div>;
}
